module.exports = __webpack_public_path__ + "static/media/item_37_2.c2e80db4.png";